import React, { useEffect, useState } from "react";
import "./DeliveryRates.scss";

import { IoSearch } from "react-icons/io5";
import { MdAddBox } from "react-icons/md";

import { useDispatch, useSelector } from "react-redux";
import { fetchDeliveries } from "../../../api/delivery";
import { Link, useNavigate } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import { storage } from "../../../helpers/storage";
import { updateDeliveries } from "../../../redux/features/organization-slice";
import SyncLoader from "../../../components/SyncLoader/SyncLoader";
import { updateNetworkStatus } from "../../../redux/features/home-slice";

const DeliveryRates = ({ setSelectedTab, setSelectedItem, desktopView }) => {
  const {
    id: organization_id,
    currency,
    deliveries: orgDeliveries,
  } = useSelector((state) => state.organizationReducer.value);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [deliveries, setDeliveries] = useState([]);
  const [backgroundLoading, setBackgroundLoading] = useState(false);
  const [backgroundLoadingFailed, setBackgroundLoadingFailed] = useState(false);
  const [keyword, setKeyword] = useState("");

  const backgroundLoadDeliveries = () => {
    setBackgroundLoading(true);
    fetchDeliveries(organization_id)
      .then((res) => {
        if (res.data) {
          const deliveries = res.data;
          storage.set("deliveries", JSON.stringify(deliveries));
          dispatch(updateDeliveries({ deliveries: deliveries }));
        }
        setBackgroundLoadingFailed(false);
      })
      .catch((err) => {
        setBackgroundLoadingFailed(true);
      })
      .finally(() => {
        setBackgroundLoading(false);
      });
  };

  useEffect(() => {
    if (organization_id) {
      backgroundLoadDeliveries();
    }
  }, [organization_id]);

  const getAllDeliveries = () => {
    if (keyword) {
      const regex = new RegExp(keyword, "i");
      const filteredDeliveries = orgDeliveries.filter((delivery) =>
        regex.test(delivery?.name)
      );
      setDeliveries(filteredDeliveries);
    } else {
      setDeliveries(orgDeliveries);
    }
    setSelectedItem && setSelectedItem(null);
    setSelectedTab && setSelectedTab("Delivery Rates");
  };

  useEffect(() => {
    getAllDeliveries();
  }, [keyword, orgDeliveries]);

  useEffect(() => {
    if (backgroundLoading) {
      dispatch(updateNetworkStatus({ status: "syncing" }));
    }
  }, [backgroundLoading]);
  return (
    <>
      <div className="delivery-setting">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setKeyword(e.target.keyword.value);
          }}
          className="delivery-search"
        >
          <div className="inputs">
            <input type="text" name="keyword" placeholder="Search delivery." />
            <button type="submit">
              <IoSearch />
            </button>
          </div>
        </form>

        <div className="delivery-list container-wrapper">
          {deliveries.length === 0 ? (
            <div className="first-item">
              <Link
                to={desktopView ? "#" : ROUTES.addDeliverySettings.path}
                onClick={() => {
                  setSelectedTab && setSelectedTab("Add Delivery Rate");
                  setSelectedItem && setSelectedItem(null);
                }}
              >
                <MdAddBox />
              </Link>
              <p>Add your first delivery rates.</p>
            </div>
          ) : (
            <>
              {deliveries.map((item, i) => {
                return (
                  <Link
                    to={desktopView ? "#" : ROUTES.editDeliverySettings.path}
                    state={desktopView ? {} : { editData: item }}
                    className="item"
                    key={i}
                    onClick={() => {
                      setSelectedTab && setSelectedTab("Edit Delivery Rate");
                      setSelectedItem && setSelectedItem(item);
                    }}
                  >
                    <p className="name">{item?.name}</p>
                    <p className="amount">
                      {currency}
                      {item?.amount}
                    </p>
                  </Link>
                );
              })}
            </>
          )}
        </div>

        <div className="add-delivery-icon">
          <MdAddBox
            onClick={() => {
              navigate(ROUTES.addDeliverySettings.path);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default DeliveryRates;
